// --- Axios instance with JWT interceptor ---
import { getConfig } from "@/config";
import * as Sentry from "@sentry/react";
import axios from "axios";

export const axiosWithAuth = (() => {
  const instance = axios.create();
  // Set baseURL
  instance.interceptors.request.use((config) => {
    const runtimeConfig = getConfig();

    if (!runtimeConfig.API_URL) {
      throw new Error("API_URL is not set in config");
    }

    config.baseURL = runtimeConfig.API_URL;

    return config;
  });
  // Add JWT access token to Authorization header
  instance.interceptors.request.use(async (config) => {
    try {
      const clerk = (window as any).Clerk
      const token = await clerk?.session?.getToken?.()

      if (!token) {
        Sentry.captureMessage("No authenticated user found", "error");
        throw new Error("No authenticated user found")
      }

      config.headers = config.headers || {}
      config.headers['Authorization'] = `Bearer ${token}`
      
      return config
    } catch (error) {
      console.error("Failed to acquire Clerk token:", error)
      throw new Error("Authentication failed", { cause: error })
    }
  });

  instance.interceptors.response.use(
    (response) => response,
    (error: unknown) => {
      const isBadRequest = axios.isAxiosError(error) && error.response?.status === 400;
      if (!axios.isCancel(error) && !isBadRequest) {
        Sentry.captureException(error);
      }
      return Promise.reject(error);
    },
  );

  return instance;
})();